import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Footer } from "./Footer";
import { Nav } from "./Nav";
import termsSource from "./terms-of-use.md?raw";
import { graphite } from "./theme";

export type TermsOfUseProps = {
  currentUser: { name: string; appUrl: string } | null;
  signInUrl: string;
  copyrightYear: number;
};

export function TermsOfUse(props: TermsOfUseProps) {
  const theme = graphite;
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        background: theme.bg,
        color: theme.fg,
        fontFamily: theme.font,
      }}
    >
      <Nav theme={theme} signInUrl={props.signInUrl} currentUser={props.currentUser} />
      <main
        className="prose prose-neutral"
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "clamp(96px, 12vw, 140px) clamp(20px, 5vw, 40px) 120px",
        }}
      >
        <Markdown remarkPlugins={[remarkGfm]}>{termsSource}</Markdown>
        <p style={{ marginTop: 48 }}>
          <a href="/" style={{ color: theme.fgMute }}>
            ← Back to home
          </a>
        </p>
      </main>
      <Footer theme={theme} copyrightYear={props.copyrightYear} />
    </div>
  );
}
